<template>
  <div id="app">
    <div class="bg-canvas">
    </div>
    <div class="glass-card">
      <!-- AI 核心 -->
      <div class="ai-core">
        <div class="core-inner"/>
        <img src="@/assets/images/logo.png" style="width: 60px;height: 60px">
      </div>
      <img alt="" class="login-title" src="@/assets/images/login2.png">
      <el-form ref="loginForm" :model="loginForm" :rules="rules" class="card-form">
        <el-form-item class="login-head-item">
          <div class="login-name-info">
            <div>用户登录</div>
            <img alt="" src="@/assets/images/login1.png"/>
          </div>
        </el-form-item>
        <!-- 账号 -->
        <el-form-item prop="mobile">
          <div class="login-tips">手机号</div>
          <div class="login-user-name">
            <div class="user-name-num">+86</div>
            <el-input
                v-model="loginForm.mobile"
                autocomplete="new-password"
                maxlength="11"
                placeholder="请输入手机号"
                @keyup.enter.native="submitForm"
            />
          </div>
        </el-form-item>
        <!-- 验证码 -->
        <el-form-item>
          <div class="login-tips">验证码</div>
          <div class="flex-item">
            <el-input
                v-model="loginForm.code"
                autocomplete="new-password"
                clearable
                maxlength="6"
                placeholder="请输入验证码"
                @keyup.enter.native="submitForm"
            />
            <button :disabled="count>0" class="code-btn" @click.prevent="codeClick()">
              <span v-show="count==0">获取验证码</span>
              <span v-show="count>0" class="count">{{ count }} s</span>
            </button>
          </div>
        </el-form-item>
        <!-- 邀请码 -->
        <el-form-item v-if="showInviteCode" prop="invite_code">
          <div class="login-tips">邀请码</div>
          <div class="flex-item">
            <el-input
                v-model="loginForm.invite_code"
                autocomplete="new-password"
                clearable
                maxlength="4"
                placeholder="请输入邀请码"
                @input="onInviteCodeInput"
                @keyup.enter.native="submitForm"
            />
          </div>
        </el-form-item>
        <!-- 登录按钮 -->
        <el-button
            :loading="loading"
            class="login-btn"
            type="primary"
            @click="submitForm"
        >
          {{ loading ? "登录中..." : "登录" }}
        </el-button>
        <div class="info-checked">
          <el-checkbox v-model="checked"><span>我已同意</span>
          </el-checkbox>
          <span class="checked-click" @click="userInfo"> 用户协议</span>
          <span> 和</span>
          <span class="checked-click" @click="privacyPolicy"> 隐私政策</span>
        </div>
      </el-form>
    </div>
    <!-- 页脚:备案号风格 -->
    <div class="tip2">杭州光合数聚科技有限公司</div>
  </div>
</template>
<script>

import {check_login_status, check_mobile_exist, login, send_code} from "@/api/login";
import {getToken, setToken} from '@/utils/auth'

export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      currentCaptcha: '',
      loginForm: {
        mobile: '',
        code: '',
        invite_code: '',
      },
      rules: {
        mobile: [{required: true, message: '手机号不可为空', trigger: 'blur'}],
        invite_code: [{
          validator: (rule, value, callback) => {
            if (value && !/^[a-zA-Z0-9]{4}$/.test(value)) {
              callback(new Error('邀请码为4位数字或字母'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
      },
      result: '',
      count: '',
      checked: true,
      showInviteCode: false,
    }
  },
  watch: {
    'loginForm.mobile'(val) {
      // 手机号满 11 位时检测是否新用户，决定是否展示邀请码
      if (val && val.length === 11) {
        this.checkMobileExist(val)
      } else {
        this.showInviteCode = false
      }
    },
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  mounted() {
    if (typeof TencentCaptcha === 'undefined') {
      this.tcaptcha = document.createElement('script')
      this.tcaptcha.src = 'https://turing.captcha.qcloud.com/TCaptcha.js'
      this.tcaptcha.async = true
      document.body.appendChild(this.tcaptcha)
    }
    this.check_login_status()
  },
  destroyed() {
    if (this.tcaptcha) document.body.removeChild(this.tcaptcha)
  },
  methods: {
    check_login_status() {
      check_login_status().then(res => {
        this.$router.replace({path: '/DifyChat/index'})
      }).catch(err => {
      })
    },
    userInfo() {
      window.open('https://szsn.tx369.com/html5/agreement?theme=light', '_blank')
    },
    privacyPolicy() {
      window.open('https://szsn.tx369.com/html5/privacy?theme=light', '_blank')
    },
    checkMobileExist(mobile) {
      check_mobile_exist({mobile}).then(res => {
        this.showInviteCode = !!res.result.need_invite_code
      }).catch(() => {
        this.showInviteCode = false
      })
    },
    onInviteCodeInput(val) {
      // 只允许数字和字母
      this.loginForm.invite_code = val.replace(/[^a-zA-Z0-9]/g, '')
    },
    getCode() {
      // 验证码倒计时
      if (!this.timer) {
        this.count = 60
        this.timer = setInterval(() => {
          if (this.count > 0) {
            this.count--
          } else {
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    },
    codeClick() {
      if (this.loginForm.mobile.length !== 11) {
        this.$message.error('请输入正确的手机号')
        return
      }
      try {
        const captcha = new TencentCaptcha('192547114', res => {
          if (res.ret === 0) {
            if (res.errorCode) {
              this.$message.error('验证失败，请重试')
            } else {
              send_code({
                mobile: this.loginForm.mobile,
                randstr: res.randstr,
                ticket: res.ticket
              }).then(res => {
                this.getCode()
              }).catch(() => {
              })
            }
          }
        }, {})
        captcha.show()
      } catch (err) {
        this.$message.error(JSON.stringify(err))
      }
    },
    submitForm() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          if (!this.checked) {
            this.$message.error('请先同意用户协议和隐私政策')
            return
          }
          this.loading = true
          login({...this.loginForm}).then(res => {
            setToken(res.result.token)
            if (getToken()) {
              this.$router.replace({path: '/DifyChat/index'})
            }
          }).catch(() => {

          }).finally(() => {
            setTimeout(() => {
              this.loading = false
            }, 1500)
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style>
:root {
  --primary: #00f2fe;
}
</style>
<style lang="scss" scoped>
::v-deep .el-form-item {
  margin-bottom: 16px;
}

::v-deep.el-input {
  --el-text-color-placeholder: #A0AEC0;
  height: 48px;

  input {
    height: 48px;

    /* 覆盖浏览器自动填充样式,关键代码 */
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-text-fill-color: #1A1A1A !important;
      transition: background-color 5000s ease-in-out 0s;
      background-color: #ffffff !important;
      caret-color: #1A1A1A !important;
    }
  }

  .el-input__prefix-inner {
    color: #1A1A1A;
  }

  .el-input__wrapper {
    background-color: transparent;
    border-radius: 0;
    /* 去掉容器内部的下划线,由外层圆角容器统一承担边框 */
    box-shadow: none !important;
  }
}

/* Element UI 样式定制 */
::v-deep .el-input__inner {
  background-color: transparent !important;
  border: 0 !important;
  color: #1A1A1A !important;
  font-size: 16px !important;
  border-radius: 0 !important;
}

::v-deep .el-input__inner:focus {
  border-color: transparent !important;
}

body {
  margin: 0;
  overflow: hidden;
}

#app {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.bg-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(at 0% 0%, rgba(10, 164, 235, 0.15) 0px, transparent 70%),
  radial-gradient(at 100% 0%, rgba(255, 182, 193, 0.2) 0px, transparent 70%),
  radial-gradient(at 100% 100%, rgba(255, 255, 150, 0.15) 0px, transparent 70%),
  radial-gradient(at 0% 100%, rgba(164, 10, 235, 0.1) 0px, transparent 70%);
  z-index: -999;
}

/* 玻璃拟态卡片 */
.glass-card {
  width: 90%;
  max-width: 460px;
  text-align: center;
}

/* AI 核心动画 */
.ai-core {
  position: relative;
  width: 120px;
  height: 120px;
  margin: 0 auto 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;

  /* 柔和的光晕,让核心更有质感 */
  &::before {
    content: "";
    position: absolute;
    inset: -26px;
    background: radial-gradient(circle, rgba(0, 242, 254, 0.18) 0%, transparent 62%);
    pointer-events: none;
  }
}

.core-inner {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 2px solid var(--primary);
  border-radius: 38% 62% 63% 37% / 41% 44% 56% 59%;
  animation: morphing 8s infinite ease-in-out;
  box-shadow: 0 0 15px rgba(0, 242, 254, 0.4);
}

@keyframes morphing {
  0% {
    border-radius: 38% 62% 63% 37% / 41% 44% 56% 59%;
    transform: rotate(0deg);
  }
  50% {
    border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;
  }
  100% {
    border-radius: 38% 62% 63% 37% / 41% 44% 56% 59%;
    transform: rotate(360deg);
  }
}

.login-title {
  width: 122px;
  height: 26px;
  margin-bottom: 24px;
  margin-top: 12px;
}

.card-form {
  border-radius: 24px;
  padding: 24px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.75) 0%, rgba(255, 255, 255, 0.55) 100%);
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 24px 60px -12px rgba(15, 23, 42, 0.12),
  0 4px 12px rgba(15, 23, 42, 0.04),
  inset 0 1px 0 rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  z-index: 99999;

  .login-head-item {
    margin-bottom: 0 !important;
  }

  .login-name-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    font-size: 24px;
    color: #0F172A;
    line-height: 32px;
    letter-spacing: 0.5px;
    padding-bottom: 18px;
    margin-bottom: 16px;
    border-bottom: 1px solid #EEF2F7;

    img {
      width: 158px;
      height: 36px;
    }
  }

  .login-tips {
    color: #64748B;
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
    margin-bottom: 8px;
    text-align: left;
    letter-spacing: 0.3px;
  }

  .login-user-name {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #1A1A1A;
    background: #ffffff;
    height: 48px;
    line-height: 48px;
    border-radius: 24px;
    box-sizing: border-box;
    padding: 0 16px;
    border: 1px solid #E2E8F0;
    transition: border-color .2s ease, box-shadow .2s ease;

    &:hover {
      border-color: #CBD5E1;
    }

    /* 聚焦时边框高亮 + 柔和光晕 */
    &:focus-within {
      border-color: #4D79FF;
      box-shadow: 0 0 0 4px rgba(77, 121, 255, 0.1);
    }

    .user-name-num {
      position: relative;
    }

    .user-name-num:after {
      position: absolute;
      top: 50%;
      right: -12px;
      content: "";
      height: 20px;
      width: 1px;
      background: #E2E8F0;
      transform: translateY(-50%);
    }
  }

  .flex-item {
    width: 100%;
    height: 48px;
    line-height: 48px;
    display: flex;
    align-items: center;
    border-radius: 24px;
    box-sizing: border-box;
    border: 1px solid #E2E8F0;
    background: #ffffff;
    transition: border-color .2s ease, box-shadow .2s ease;

    &:hover {
      border-color: #CBD5E1;
    }

    &:focus-within {
      border-color: #4D79FF;
      box-shadow: 0 0 0 4px rgba(77, 121, 255, 0.1);
    }

    button.code-btn {
      position: relative;
      color: #4D79FF;
      font-size: 16px;
      font-weight: 500;
      background: transparent;
      border: 0;
      width: 110px;
      height: 48px;
      line-height: 48px;
      cursor: pointer;
      flex-shrink: 0;
      transition: color .2s ease;

      /* 与输入框之间的细分隔线 */
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 1px;
        height: 18px;
        background: #E2E8F0;
      }

      &:hover:not(:disabled) {
        color: #3D6BFF;
      }

      &:disabled {
        color: #94A3B8;
        cursor: not-allowed;
      }
    }
  }

  .login-btn {
    width: 100%;
    height: 48px;
    margin-top: 16px;
    border: 0;
    border-radius: 24px;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 4px;
    background: linear-gradient(135deg, #4D79FF 0%, #6C8CFF 100%) !important;
    box-shadow: 0 10px 24px -6px rgba(77, 121, 255, 0.45);
    transition: all .2s ease;

    &:hover {
      background: linear-gradient(135deg, #3D6BFF 0%, #5F7FFF 100%) !important;
      box-shadow: 0 12px 28px -6px rgba(77, 121, 255, 0.55);
    }

    &:active {
      transform: translateY(1px);
      box-shadow: 0 6px 16px -4px rgba(77, 121, 255, 0.4);
    }
  }

  .info-checked {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #94A3B8;
    line-height: 20px;
    padding-top: 32px;

    ::v-deep .el-checkbox__label {
      font-size: 14px;
      color: #94A3B8 !important;
      font-weight: 400;
    }

    .checked-click {
      cursor: pointer;
      color: #4D79FF;
      transition: opacity .2s ease;

      &:hover {
        opacity: 0.8;
      }
    }
  }
}

.flex {
  display: flex;
}


#captchaCanvas {
  width: 100px;
  height: 40px;
  border-radius: 8px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.1);

  img {
    width: 100px;
    height: 40px;
    border-radius: 8px;
  }
}


/* 页脚:备案号风格,固定在页面底部居中 */
.tip2 {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 20px;
  text-align: center;
  letter-spacing: 0.5px;
  color: #94A3B8;
  line-height: 20px;
  z-index: 9999;
}

::v-deep .el-checkbox__label {
  color: #9ca3af !important;
  font-size: 12px;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #4D79FF !important;
  border-color: #4D79FF !important;
}
</style>
